'use client';

import { useEffect } from 'react';
import { useRouter, usePathname } from 'next/navigation';

import NProgress from 'nprogress';

// Configure NProgress for super smooth transitions
NProgress.configure({
  showSpinner: false,
  trickle: true,
  trickleSpeed: 50,
  minimum: 0.02,
  easing: 'linear',
  speed: 200,
  parent: 'body'
});

const ProgressProvider = ({ children }) => {
  const router = useRouter();
  const pathname = usePathname();


  // Override router methods to show progress
  useEffect(() => {
    const originalPush = router.push;
    const originalReplace = router.replace;
    const originalBack = router.back;
    const originalForward = router.forward;

    // Override router methods with smooth delay
    router.push = (...args) => {
      setTimeout(() => NProgress.start(), 50);
      return originalPush.apply(router, args);
    };

    router.replace = (...args) => {
      setTimeout(() => NProgress.start(), 50);
      return originalReplace.apply(router, args);
    };

    router.back = (...args) => {
      setTimeout(() => NProgress.start(), 50);
      return originalBack.apply(router, args);
    };

    router.forward = (...args) => {
      setTimeout(() => NProgress.start(), 50);
      return originalForward.apply(router, args);
    };

    // Handle browser back/forward buttons
    const handlePopState = () => {
      setTimeout(() => NProgress.start(), 50);
    };

    window.addEventListener('popstate', handlePopState);

    // Cleanup
    return () => {
      router.push = originalPush;
      router.replace = originalReplace;
      router.back = originalBack;
      router.forward = originalForward;
      window.removeEventListener('popstate', handlePopState);
    };
  }, [router]);

  // Complete progress when route changes
  useEffect(() => {
    NProgress.done();
  }, [pathname]);



  return children;
};

export default ProgressProvider;
